<script>
import useAdjustmentCoefficients
  from "@/composables/financial_management/definition_adjustment_coefficients/useAdjustmentCoefficients"

export default {
  async mounted() {
    await this.fetchData('product')
  },

  data() {
    return {
      ...useAdjustmentCoefficients().data()
    }
  },

  methods: {
    ...useAdjustmentCoefficients().methods,
  }
}
</script>

<template>
  <div class="p-3">
    <div class="table-container">
      <div class="table-responsive" v-if="years?.length > 0 && items?.length > 0">
        <table class="table c-table">
          <thead>
          <tr>
            <th rowspan="2" class="align-middle sticky-column">سال</th>
            <th v-for="item in items" :key="item.id" colspan="2" class="text-center">
              {{ item.title }}
            </th>
            <th colspan="2" class="text-center">قیمت پایه محصول با روش لاسپیرز زنجیره ای</th>
            <th colspan="2" class="text-center">قیمت پایه محصول با روش پاشه زنجیره ای</th>
            <th colspan="2" class="text-center">قیمت پایه محصول با روش فیشر زنجیره ای</th>
          </tr>

          <tr>
            <template v-for="item in items" :key="`${item.id}-subheader`">
              <th class="text-center">حجم خرید</th>
              <th class="text-center">قیمت هر واحد (میلیون ریال)</th>
            </template>

            <th class="text-center">شاخص لاسپیرز</th>
            <th class="text-center">شاخص لاسپیرز زنجیره ای</th>
            <th class="text-center">شاخص پاشه</th>
            <th class="text-center">شاخص پاشه زنجیره ای</th>
            <th class="text-center">شاخص فیشر زنجیره ای</th>
            <th class="text-center">شاخص فیشر زنجیره ای نهایی</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="year in years" :key="year">
            <td class="sticky-column">{{ year }}</td>

            <template v-for="item in items" :key="`${item.id}-${year}`">
              <td>
                <input
                    type="number"
                    class="form-control form-control-sm border-0 text-center"
                    v-model="item.yearlyData[year].volume"
                    @input="handleItemDataChange(item.id, year, item.yearlyData[year].volume, item.yearlyData[year].price)"
                />
              </td>
              <td>
                <input
                    type="number"
                    class="form-control form-control-sm border-0 text-center"
                    v-model="item.yearlyData[year].price"
                    step="0.001"
                    @input="handleItemDataChange(item.id, year, item.yearlyData[year].volume, item.yearlyData[year].price)"
                />
              </td>
            </template>

            <!-- لاسپیرز -->
            <td>
              {{ laspeyres[year].index }}
            </td>
            <td>
              {{ laspeyres[year].chainIndex }}
            </td>

            <!-- پاشه -->
            <td>
              {{ paasche[year].index }}
            </td>
            <td>
              {{ paasche[year].chainIndex }}
            </td>

            <!-- فیشر -->
            <td>
              {{ fisher[year].index }}
            </td>
            <td>
              {{ fisher[year].chainIndex }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="alert alert-info m-3">
        موردی وجود ندارد
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-control-sm {
  height: 2vw;
  padding: .2vw .5vw;
}

.table td, .table th {
  text-align: center;
}

td {
  font-size: 1vw !important;
}

.table input[type="number"] {
  text-align: center;
  min-width: 9vw;
}

/* To remove the numeric Input Flash */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.table-responsive::-webkit-scrollbar {
  height: .6vw;
}

th.sticky-column, td.sticky-column {
  position: sticky;
  right: -.1vw;
  z-index: 3;
  box-shadow: inset .4vw 0 .4vw -.4vw rgba(255, 255, 255, 0.4);
  min-width: 4vw;
}

tbody > tr:nth-child(odd) > td.sticky-column {
  background-color: #86d1fc;
}

tbody > tr:nth-child(even) > td.sticky-column {
  background-color: #bde6fe;
}
</style>
